
import * as React from "react"
import { cn } from "@/lib/utils"
import { useSidebar } from "./sidebar-provider"

const SidebarHeader = ({ className, children, ...props }: React.HTMLAttributes<HTMLElement>) => {
  const { isCollapsed } = useSidebar();
  
  return (
    <div 
      className={cn(
        "py-4 border-b flex items-center justify-center", 
        isCollapsed ? "px-2" : "px-4",
        className
      )} 
      {...props}
    >
      {children}
    </div>
  )
}
SidebarHeader.displayName = "SidebarHeader"

export { SidebarHeader }
